import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken';

async function request(method, path, data) {
  const token = await retrieveAccessToken();
  const response = await axios({ method, url: `/api/editor/${path}`, data,
    headers: token ? { Authorization: `Bearer ${token}` } : {} });
  return response.data;
}
export const createCourseDraft = () => request('post', 'course-drafts');
export const editCourseDraft = (courseId, fresh = false) => request('post', `course/${encodeURIComponent(courseId)}/draft${fresh ? '?fresh=true' : ''}`);
export const listCourseDrafts = () => request('get', 'course-drafts');
export const getCourseDraft = id => request('get', `course-drafts/${encodeURIComponent(id)}`);
export const saveCourseDraft = (id, draft) => request('put', `course-drafts/${encodeURIComponent(id)}`, draft);
export const publishCourseDraft = id => request('post', `course-drafts/${encodeURIComponent(id)}/publish`);
